/**
 * Контекст отзыва: страница, устройство, приложение — снимается в момент открытия формы.
 */
import { casperBridgeGetVersion, isCasperBridgeAvailable } from "@/lib/casper-bridge"
import type { FeedbackContext } from "../shared/types"

const MOBILE_TAB_KEY = "mobile-active-tab-v1"
const MOBILE_TABS: Record<string, string> = { areas: "Задачи", files: "Библиотека", incidents: "Инциденты", copilot: "Копилот", messenger: "Мессенджер", account: "Аккаунт" }

let appVersion: Promise<string | null> | null = null

function nativeVersion(): Promise<string | null> {
  if (!isCasperBridgeAvailable()) return Promise.resolve(null)
  appVersion ??= Promise.race([
    casperBridgeGetVersion().then((v) => (v?.version ? `${v.version}${v.buildNumber ? ` (${v.buildNumber})` : ""}` : null)).catch(() => null),
    new Promise<null>((r) => setTimeout(() => r(null), 800)),
  ])
  return appVersion
}

function mobileTab(path: string): string | null {
  if (path !== "/mobile") return null
  try {
    const t = localStorage.getItem(MOBILE_TAB_KEY)
    return t ? (MOBILE_TABS[t] ?? t) : null
  } catch {
    return null
  }
}

export async function collectContext(extra: Partial<FeedbackContext> = {}): Promise<FeedbackContext> {
  const path = window.location.pathname
  const coarse = window.matchMedia?.("(pointer: coarse)").matches
  const platform: FeedbackContext["platform"] = isCasperBridgeAvailable() ? "app" : path.startsWith("/mobile") || (coarse && window.innerWidth < 900) ? "mobile" : "desktop"
  return {
    url: window.location.href,
    path,
    title: document.title,
    platform,
    mobileTab: mobileTab(path),
    appVersion: await nativeVersion(),
    userAgent: navigator.userAgent,
    viewport: `${window.innerWidth}×${window.innerHeight}`,
    screen: `${window.screen.width}×${window.screen.height}`,
    pixelRatio: window.devicePixelRatio,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    referrer: document.referrer || null,
    online: navigator.onLine,
    ...extra,
  }
}
